package com.exura.navigation

import com.exura.components.layouts.plan.LayoutMode
import com.exura.navigation.Route.Params.COLLECTION_ID
import com.exura.navigation.Route.Params.PLAN_ID
import com.exura.navigation.Route.Params.PUBLIC_PLAN_ENTRY_ID
import com.exura.navigation.Route.Params.SERIES_ID

internal object Route {
    const val LOGIN = "/login"
    const val REGISTER = "/register"
    const val DASHBOARD = "/dashboard"
    const val PLAN_CREATOR = "/plan-creator"
    const val IMPORT_PLANS = "/import-plans"
    const val SETTINGS = "/settings"
    const val PLAN_DISTRIBUTION = "/plan-distribution"
    const val PLAN_PREVIEW = "/plan-preview"
    const val PUBLIC_PLAN = "/publicplan"

    object Params {
        const val PLAN_ID = "planId"
        const val SERIES_ID = "seriesId"
        const val COLLECTION_ID = "collectionId"

        const val VIEW_MODE = "viewMode"
        const val LAYOUT_MODE = "layoutMode"

        const val PLAN_TYPE = "planType"
        const val DISPLAY_MODE = "graphMode"
        const val DISPLAY_RANGE = "displayRange"
        const val DISPLAY_OFFSET = "displayOffset"
        const val SERIES_INDEX = "seriesIndex"
        const val COLLECTION_INDEX = "collectionIndex"
        const val PUBLIC_PLAN_ENTRY_ID = "publicPlanEntryId"
    }

    object WithParams {

        const val PUBLIC_PLAN_DETAILS = "$PUBLIC_PLAN/{$PUBLIC_PLAN_ENTRY_ID}"
        const val PLAN_DISTRIBUTION_DETAILS = "$PLAN_DISTRIBUTION/{$PLAN_ID}"
        const val PLAN_PREVIEW_DETAILS = "$PLAN_PREVIEW/{$PLAN_ID}"
        const val DIRECT_SERIES_DETAILS = "$PLAN_PREVIEW/{$PLAN_ID}/series/{$SERIES_ID}"
        const val NESTED_SERIES_DETAILS = "$PLAN_PREVIEW/{$PLAN_ID}/collection/{$COLLECTION_ID}/series/{$SERIES_ID}"
        const val COLLECTION_DETAILS = "$PLAN_PREVIEW/{$PLAN_ID}/collection/{$COLLECTION_ID}"

        fun toPlanDistribution(planId: String): String = "$PLAN_DISTRIBUTION/$planId"

        fun toPublicPlanDetails(
            publicPlanEntryId: String? = null
        ): String = if (publicPlanEntryId != null) {
            "$PUBLIC_PLAN/$publicPlanEntryId"
        } else {
            PUBLIC_PLAN
        }

        fun toPlanPreview(
            planId: String,
            layoutMode: LayoutMode? = null,
        ) = if (layoutMode == null)
            "$PLAN_PREVIEW/$planId"
        else
            "$PLAN_PREVIEW/$planId?${Params.LAYOUT_MODE}=$layoutMode"

        fun toCollectionPreview(
            planId: String,
            collectionId: String,
        ) = "$PLAN_PREVIEW/$planId/collection/$collectionId"

        fun toSeriesPreview(
            planId: String,
            collectionId: String?,
            seriesId: String,
        ) = if (collectionId == null) "$PLAN_PREVIEW/$planId/series/$seriesId"
        else "$PLAN_PREVIEW/$planId/collection/$collectionId/series/$seriesId"
    }
}
